// useMealPlanGeneration.js — Constants and utilities for meal plan generation

export const TOTAL_EXPECTED_RECIPES = 9;

/**
 * Validate meal plan structure
 * @param {Array} mealPlan - The meal plan array to validate
 * @returns {boolean} Whether the meal plan has a valid structure
 */
export const validateMealPlanStructure = (mealPlan) => {
  if (!Array.isArray(mealPlan) || mealPlan.length === 0) return false;
  return mealPlan.every(
    (recipe) =>
      recipe.title &&
      recipe.mealType &&
      ["Breakfast", "Lunch", "Dinner"].includes(recipe.mealType)
  );
};
